import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { UpdateSelectedProcedure } from '../../../store/actions/selected-procedure.actions';
import { ChangeOffersEligibleListInterfaceState } from '../../../store/state/change-offers-eligible-list.state';
import { SaveMission } from '../../../store/actions/mission.actions';
import { ChangeOfferInterface } from '../../../models/change-offer.interface';
import { AddressInterfaceState } from '../../../../account/store/state/address.state';
import { AddressInterface } from '../../../../account/models/address.interface';
import { LineInterface } from '../../../../lines/models/line.interface';
import { GetChangeOffersEligibleList } from '../../../store/actions/change-offers-eligible-list.actions';
import { PriceDetailsInterface } from '../../../models/price-details.interface';
import { GetAddress } from '../../../../account/store/actions/address.actions';
import { ConstsHelper } from '../../../../../helpers/consts.helper';
import { GetOfferDetails } from '../../../../lines/store/actions/offer-details.actions';
import { OfferDetailsInterface } from '../../../models/offer-details.interface';
import { OfferDetailsInterfaceState } from '../../../../lines/store/state/offer-details.state';
import { environment } from '../../../../../../environments/environment';
import { PriceFormatService } from '../../../services/price-format.service';
import { FormControl} from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import moment from 'moment';
import { OfferPromoDetailsInterface } from '../../../../lines/models/offer-promo-details.interface';
import { VitrineOfferInterface } from '../../../models/vitrine-offer.interface';
import { OfferShuntersInterface } from '../../../models/offer-shunters.interface';

@Component({
  selector: 'app-change-offer',
  templateUrl: './change-offer.component.html',
  styleUrls: ['./change-offer.component.css'],
  standalone: false
})
export class ChangeOfferComponent implements OnInit {

  offerCode: string;
  offerName: string;
  environment = environment;
  formSubmitted: boolean;

  @Input()
  line: LineInterface;

  @Input()
  procedureCode: string;

  @Input()
  priceDetails?: PriceDetailsInterface;

  @Input()
  dates: Array<string>;

  step: number;
  type: string;
  steps: number;
  offerDetails: OfferDetailsInterface = null;
  selectedOffer: VitrineOfferInterface = null;
  offerPromoDetails: OfferPromoDetailsInterface = null;
  changeOffersEligibleList: Array<VitrineOfferInterface> = [];
  shippingAddress: AddressInterface|null;
  dateChange: EventEmitter<MatDatepickerInputEvent<Date>>;
  validDates: Date[];
  startDate: FormControl;
  selectedDate: Date;
  displayError: boolean;
  thirdStep: string;
  oldOffersRegex = /essentiel|modulo|chrono/;
  months = {
    '01' : 'de Janvier',
    '02' : 'de Février',
    '03' : 'de Mars',
    '04' : 'd\'Avril',
    '05' : 'de Mai',
    '06' : 'de Juin',
    '07' : 'de Juillet',
    '08' : 'd\'Août',
    '09' : 'de Septembre',
    '10' : 'd\'Octobre',
    '11' : 'de Novembre',
    '12' : 'de Décembre'
  };
  brand?: string;

  constructor(
      public priceFormatService: PriceFormatService,
      private store: Store<any>,
      private matIconRegistry: MatIconRegistry,
      private domSanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    this.store.pipe(select(ConstsHelper.REDUCER_OFFER_DETAILS)).subscribe( (result: OfferDetailsInterfaceState) => {
      if (null != result.offerDetails) {
        this.offerDetails = result.offerDetails;
      }
    });

    this.shippingAddress = null;
    this.store.pipe(select(ConstsHelper.REDUCER_ADDRESS)).subscribe( (result: AddressInterfaceState) => {
      if (null != result.address) {
        for (const addr of result.address) {
          if (addr.isPrincipal) {
            this.shippingAddress = addr;
          }
        }
      }
    });

    this.brand = environment.data.brand;
    this.store.pipe(select(ConstsHelper.REDUCER_CHANGE_OFFERS_ELIGIBLE_LIST)).subscribe((response: ChangeOffersEligibleListInterfaceState) => {
      if (null != response.response) {
        this.changeOffersEligibleList = [];
        const amortization = this.line.offer.packages.includes('2809') || this.line.offer.packages.includes('2810') || this.line.offer.packages.includes('2811');
        if (response.response.length === 0) {
          this.steps = null;
        }
        response.response.forEach((item, index) => {
          if (
              item.hidden !== true &&
              (
                  (
                      this.brand === 'coriolis' &&
                      Math.max(...this.line.offer.shunters.prices) <= item.base_price_ttc &&
                      (
                          !amortization ||
                          amortization &&
                          (
                              item.packages.includes('2809') ||
                              item.packages.includes('2810') ||
                              item.packages.includes('2811')
                          )
                      )
                  ) ||
                  this.brand === 'prixtel'
              )
          ) {
            this.changeOffersEligibleList.push(item);
            if (index === 0) {
              this.selectedOffer = this.changeOffersEligibleList[0];
              this.store.dispatch(new GetOfferDetails(this.selectedOffer.offer_id));
            }
          }
        });
      }
    });

    this.store.dispatch(new GetChangeOffersEligibleList(this.line.offer.id, this.line.phoneNumber));
    this.offerName = this.line.offer.labelTunnel;
    this.offerCode = this.line.offer.label2.toLowerCase();
    this.formSubmitted = false;
    this.step = 1;
    this.steps = 3;
    this.type = 'next_month';
    this.thirdStep = 'Date d\'application de votre nouveau forfait';

    if (this.line.oberthur === false) {
      this.displayError = false;
      this.selectedDate = null;
      this.dates = [];
      this.store.dispatch(new GetAddress());
      this.matIconRegistry.addSvgIcon(
          'agenda',
          this.domSanitizer.bypassSecurityTrustResourceUrl(
            '../../../../../../../assets/images/icons/' + this.brand + '_small-agenda.svg'
          )
      );
      this.store.dispatch(new GetAddress());
      this.steps = 4;
    }
    if (this.line.network.toLowerCase() === 'orange') {
      this.store.dispatch(new GetAddress());
      this.initDates(this.dates);
      this.steps = 3;
      this.thirdStep = 'Changement gratuit de carte SIM';
    }
  }

  setSelectedOffer(event) {
    for (const offer of this.changeOffersEligibleList) {
      if (offer.offer_id === parseInt(event.target.value, 10)) {
        this.selectedOffer = offer;
        this.offerDetails = null;
        this.store.dispatch(new GetOfferDetails(this.selectedOffer.offer_id));
      }
    }
  }

  changeType(type: string) {
    this.type = type;
  }

  setSelectedDate(event) {
    this.selectedDate = event;
  }

  initDates(dates: string[]) {
    this.validDates = [];
    dates.forEach(d => {
      const momentDate = moment(d, 'DD/MM/YYYY');
      this.validDates.push(new Date(momentDate.format('YYYY-MM-DD')));
    });
    this.selectedDate = this.validDates[0];
    this.startDate = new FormControl(this.validDates[0]);
  }

  portabilityDateFilter = (forDay: Date | null): boolean => {
    return this.validDates.some(
        (date) => date.toDateString() === forDay.toDateString()
    );
  }

  cancel() {
    this.store.dispatch(new UpdateSelectedProcedure(''));
  }

  setStep(step: number) {
    this.step += step;
    document.getElementById('wrapper-content').scrollTop = 0;
    if (this.step === 4 && this.line.oberthur === true && this.line.network.toLowerCase() === 'sfr') {
      this.confirmation();
    }
  }

  orangeConfirmation() {
    this.displayError = false;
    if (this.dates.indexOf(moment(this.selectedDate).format('DD/MM/YYYY')) !== -1 && this.formSubmitted === false) {
      this.formSubmitted = true;
      const changeOfferInterface = {
        step: 1,
        phoneNumber: this.line.phoneNumber,
        typeChange: 'free_immediate',
        swap: !this.line.oberthur,
        offerId: this.selectedOffer.offer_id,
        currentOfferId: this.line.offer.id,
        isOrangeCompatible: false,
        isSfrCompatible: true,
        currentOfferName: this.line.offer.labelTunnel,
        offerName: this.selectedOffer.label,
        shippingAddressId: this.shippingAddress ? this.shippingAddress.id : null,
        currentNetwork: this.line.network,
        newNetwork: 'sfr',
        notificationMonth: this.getMonth(),
        portabilityDate: moment(this.selectedDate).format('YYYY-MM-DD'),
        isOldOffer: null,
        frStartPromo: null,
        frEndPromo: null,
        inPromo: null,
        isLastMonth: null,
      } as ChangeOfferInterface;
      this.store.dispatch(new SaveMission(changeOfferInterface, this.procedureCode));
    } else {
      document.getElementById('wrapper-content').scrollTop = 0;
      this.displayError = true;
    }
  }

  confirmation() {
    if (this.formSubmitted === false) {
      this.formSubmitted = true;
      const changeOfferInterface = {
        step: 1,
        phoneNumber: this.line.phoneNumber,
        typeChange: this.type,
        swap: !this.line.oberthur,
        offerId: this.selectedOffer.offer_id,
        currentOfferId: this.line.offer.id,
        isOrangeCompatible: false,
        isSfrCompatible: true,
        currentOfferName: this.line.offer.labelTunnel,
        offerName: this.selectedOffer.label,
        shippingAddressId: this.shippingAddress ? this.shippingAddress.id : null,
        currentNetwork: this.line.network,
        newNetwork: null,
        portabilityDate: null,
        isOldOffer: this.oldOffersRegex.test(this.line.offer.labelTunnel.toLowerCase()),
        frStartPromo: null,
        frEndPromo: null,
        inPromo: null,
        isLastMonth: null,
      } as ChangeOfferInterface;
      this.store.dispatch(new SaveMission(changeOfferInterface, this.procedureCode));
    }
  }

  getMonth() {
    return this.months[moment(this.selectedDate).format('MM')];
  }

  getEndDate() {
    const endDate = moment(this.selectedDate.toISOString().split('T')[0], 'YYYY-MM-DD').add(11, 'months');
    return this.months[endDate.format('MM')].replace(/de|d\'/g, '') + ' ' + endDate.format('YYYY');
  }

  getPriceText() {
    let text = '';
    if (this.offerDetails.shunters_price.length >= 3) {
      text += 'Avec ce forfait, vous paierez de <strong>' + this.priceFormatService.get((this.offerDetails.shunters_price[0] * 1.2).toString()) + ' à ' + this.priceFormatService.get((this.offerDetails.shunters_price[this.offerDetails.shunters_price.length - 1] * 1.2).toString()) + ' par mois</strong>';
    } else {
      text += 'Avec ce forfait, vous paierez <strong>' + this.priceFormatService.get((this.offerDetails.shunters_price[0] * 1.2).toString()) + ' par mois</strong>';
    }

    return text + '.';
  }

  getShunters(offerDetails: OfferDetailsInterface) {
    const shunters: OfferShuntersInterface = { data: [], prices: [] };
    for (const price of offerDetails.shunters_price) {
      shunters.prices.push(parseFloat((price * 1.2).toFixed(2)));
    }
    for (const data of offerDetails.shunters_data) {
      shunters.data.push((data === 0) ? '0' : (data / 1000000) + 'Go');
    }
    return shunters;
  }

  getBillCycleDate() {
    const billingCycleDay = this.line.billingCycleDay < 10 ? '0' + this.line.billingCycleDay : this.line.billingCycleDay.toString();
    if (parseInt(moment().format('YYYYMMDD'), 10) < parseInt(moment().format('YYYYMM') + billingCycleDay, 10)) {
      return billingCycleDay + '/' + moment().format('MM/YYYY');
    } else {
      return billingCycleDay + '/' + moment().add(1, 'months').format('MM/YYYY');
    }
  }
}
